import React, { useState, useEffect } from 'react';
import logo from './sindikat_new.jpg';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from "react-router-dom";
import './Login.css';

export const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [pass, setPass] = useState('');
  const [clan, setClan] = useState({
    id: "",
    ime: "",
    prezime: "",
    datum: null,
    adresa: "",
    oib: "",
    email: "",
    mobitel: "",
    ustanovaRada: "",
    sifra: "",
    kartica: "",
    aktivacija: ""
  });

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  useEffect(() => {
    if (clan.ime) {
      if (clan.sifra !== pass) {
        toast("Pogrešna lozinka, pokušajte ponovo!");
      } else if (clan.aktivacija === "N") {
        toast("Korisnički račun je u statusu aktivacije");
      } else {
        navigate("/kartice", {
          state: { Iime: clan.ime + " " + clan.prezime, Ikartica: clan.kartica }
        });
      }
    }
  }, [clan]);

  function sendLoginRequest() {
    if (!email) {
      toast("Nije upisana e-mail adresa");
    } else if (!pass) {
      toast("Nije upisan password");
    } else {
      fetch('https://sind-zajedno.times.hr/clanovi/' + email)
        .then((response) => {
          if (!response.ok) throw Error(response.statusText);
          return response.json();
        })
        .then((data) => setClan(data))
        .catch(() => {
          toast("Molim vas napravite registraciju, ne postoji račun sa ovom E-mail adresom!");
        });
    }
  }

  function posaljiMailZaOporavak() {
    if (!email) {
      toast("Nije upisana e-mail adresa za oporavak lozinke");
    } else {
      fetch('https://sind-zajedno.times.hr/lozinka/' + email)
        .then((response) => {
          if (!response.ok) throw Error(response.statusText);
          return response.text();
        })
        .then((text) => toast(text))
        .catch((error) => console.log('404 Not Found: ' + error));
    }
  }

  return (
    <div className="modern-form">
      <form className="login-form" onSubmit={handleSubmit}>
        <img src={logo} className="App-logo" alt="logo" />
        <h2 className="form-title">Prijava</h2>

        <label htmlFor="email">E-mail</label>
        <input
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          type="email"
          placeholder="youremail@gmail.com"
          id="email"
          name="email"
        />

        <label htmlFor="password">Lozinka</label>
        <input
          value={pass}
          onChange={(e) => setPass(e.target.value)}
          type="password"
          placeholder="********"
          id="password"
          name="password"
        />

        <div className="button-group">
          <button type="button" className="btn btn-primary" onClick={sendLoginRequest}>
            Prijava
          </button>
          <button type="button" className="btn btn-secondary" onClick={() => navigate("/register")}>
            Registracija
          </button>
        </div>

        <button type="button" className="link-btn" onClick={posaljiMailZaOporavak}>
          Zaboravili ste lozinku?
        </button>

        <ToastContainer />
      </form>
    </div>
  );
};
